<table class="table table-striped table-hover payment-package-table" style="line-height: 1.428">
    <thead>
        <tr>
            <th style="width: 20px">
                @if (shouldShowSelectAll) {
                    <input
                        type="checkbox"
                        [indeterminate]="
                            selectedCount > 0 && selectedCount < paymentPackages.length
                        "
                        [checked]="selectedCount === paymentPackages.length"
                        (click)="toggleSelectAll()"
                        [disabled]="isDisabled"
                    />
                }
            </th>
            <th style="width: 5%">Package #</th>
            <th style="width: 5%">Sent</th>
            <th style="width: 15%">Responsible Party</th>
            <th style="width: 18%">Cc/Bcc</th>
            <th colspan="2" style="width: 40%">
                <table style="width: 100%">
                    <tr>
                        <th width="70%">Transmittals</th>
                        <th width="30%">Payment Count</th>
                    </tr>
                </table>
            </th>
            <th style="width: 20%">Special Instructions</th>
            @if (readOnly && !isModal) {
                <th>Recall?</th>
            }
        </tr>
    </thead>
    <tbody>
        @for (package of paymentPackages; track package) {
            <tr
                (click)="selectRow($event, package)"
                [style.font-style]="package.completedDateTime ? 'italic' : 'normal'"
                [style.color]="package.isRecalled ? '#a3a4b2' : 'var(--ace-neutral-800)'"
            >
                <td>
                    @if (!package.completedDateTime) {
                        <input
                            type="checkbox"
                            [(ngModel)]="package.isSelected"
                            [disabled]="isDisabled"
                        />
                    }
                </td>
                <td>
                    @if (!package.completedDateTime) {
                        <span>
                            <a
                                class="no-bubble"
                                style="cursor: pointer"
                                [style.color]="package.isRecalled ? '#80C7FF' : '#337ab7'"
                                (click)="openReviewModal($event, package)"
                            >
                                {{ package.transmittalType }} Draft {{ package.packageNumber }}
                            </a>
                        </span>
                    }
                    @if (package.completedDateTime) {
                        <span>
                            <a
                                class="no-bubble"
                                style="cursor: pointer"
                                (click)="openReviewModal($event, package)"
                                [style.color]="package.isRecalled ? '#80C7FF' : '#337ab7'"
                            >
                                {{ package.transmittalType }} - {{ package.packageNumber }}
                            </a>
                        </span>
                    }
                </td>
                <td>
                    @if (!package.completedDateTime) {
                        <span>
                            Draft
                            @if (package.lockedForOverrideEmail) {
                                <i
                                    class="no-bubble fa fa-lock"
                                    style="cursor: pointer; margin-left: 3px;"
                                    tooltip="This package is locked for editing because the email has been customized; click to unlock"
                                    (click)="unlockPackage($event, package)"
                                >
                                </i>
                            }
                        </span>
                    }
                    @if (package.completedDateTime) {
                        <span>{{ package.completedDateTime | weissmanDateFormat }}</span>
                    }
                </td>
                <td>
                    @if (!isPrelimApFeed) {
                        @for (recipient of package.paymentPackageRecipients; track recipient) {
                            <div>
                                @if (recipient.recipientType === RecipientType.ResponsibleParty) {
                                    <span
                                        [tooltip]="recipientAddress"
                                        (mouseenter)="setHoveredRecipient(recipient)"
                                    >
                                        {{ recipient.fullName }}
                                    </span>
                                }
                            </div>
                        }
                    }
                    @if (isPrelimApFeed) {
                        <div>N/A</div>
                    }
                </td>
                <td>
                    @if (!isPrelimApFeed) {
                        @if (getRecipientCount(package.paymentPackageRecipients) > 0) {
                            <div>
                                @for (
                                    recipient of package.paymentPackageRecipients
                                        | recipientType: { recipientType: RecipientType.Cc };
                                    track recipient
                                ) {
                                    <div class="delete-hover">
                                        <div>
                                            <div
                                                style="width: 84%"
                                                class="float-start"
                                                [tooltip]="recipientAddress"
                                                (mouseenter)="setHoveredRecipient(recipient)"
                                            >
                                                <span>CC: </span>
                                                {{ recipient.fullName }}
                                            </div>
                                            @if (
                                                !readOnly &&
                                                !package.completedDateTime &&
                                                !package.lockedForOverrideEmail
                                            ) {
                                                <i
                                                    class="no-bubble fa fa-close hidden-hover float-end"
                                                    (click)="
                                                        removeRecipient($event, recipient, package)
                                                    "
                                                >
                                                </i>
                                            }
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                }
                                @for (
                                    recipient of package.paymentPackageRecipients
                                        | recipientType: { recipientType: RecipientType.Bcc };
                                    track recipient
                                ) {
                                    <div class="delete-hover">
                                        <div>
                                            <div
                                                style="width: 84%"
                                                class="float-start"
                                                [tooltip]="recipientAddress"
                                                (mouseenter)="setHoveredRecipient(recipient)"
                                            >
                                                <span>BCC: </span>
                                                {{ recipient.fullName }}
                                            </div>
                                            @if (
                                                !readOnly &&
                                                !package.completedDateTime &&
                                                !package.lockedForOverrideEmail
                                            ) {
                                                <i
                                                    class="no-bubble fa fa-close hidden-hover float-end"
                                                    (click)="
                                                        removeRecipient($event, recipient, package)
                                                    "
                                                >
                                                </i>
                                            }
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                }
                                @if (
                                    !readOnly &&
                                    !package.completedDateTime &&
                                    !package.lockedForOverrideEmail
                                ) {
                                    <div class="hidden-col-hover">
                                        <button
                                            class="no-bubble ace-btn btn-sm btn-primary"
                                            (click)="openContactModal($event, package)"
                                        >
                                            Add
                                        </button>
                                    </div>
                                }
                            </div>
                        }
                        @if (getRecipientCount(package.paymentPackageRecipients) === 0) {
                            <div style="font-style: italic">
                                There are no other recipients
                                @if (
                                    !readOnly &&
                                    !package.completedDateTime &&
                                    !package.lockedForOverrideEmail
                                ) {
                                    <div class="hidden-col-hover">
                                        <button
                                            class="no-bubble ace-btn btn-sm btn-primary"
                                            (click)="openContactModal($event, package)"
                                        >
                                            Add
                                        </button>
                                    </div>
                                }
                            </div>
                        }
                    }
                    @if (isPrelimApFeed) {
                        <div>N/A</div>
                    }
                </td>
                <td colspan="2">
                    <div style="max-height: 220px; overflow: auto">
                        <table style="width: 100%">
                            <tr>
                                <td width="80%" style="vertical-align: top">
                                    {{ package.companyName }}
                                </td>
                                <td></td>
                            </tr>
                            @for (
                                transmittal of package.paymentTransmittals;
                                track transmittal;
                                let i = $index
                            ) {
                                <tr class="delete-hover">
                                    <td width="80%" style="vertical-align: top; position: relative">
                                        <a
                                            class="no-bubble float-start"
                                            [style.color]="
                                                package.isRecalled ? '#80C7FF' : '#337ab7'
                                            "
                                            style="cursor: pointer"
                                            (click)="goToDetails(transmittal, package)"
                                        >
                                            @if (transmittal.collectorAddress.abbr) {
                                                <span
                                                    >{{ transmittal.collectorAddress.abbr }} -</span
                                                >
                                            }
                                            {{ transmittal.title }}
                                        </a>
                                        @if (
                                            !readOnly &&
                                            !package.completedDateTime &&
                                            !package.lockedForOverrideEmail &&
                                            !isFromPaymentBatch
                                        ) {
                                            <i
                                                class="no-bubble fa fa-close hidden-hover float-end"
                                                style="position: absolute; right: -8%"
                                                (click)="removeTransmittal($event, package, i)"
                                            >
                                            </i>
                                        }
                                    </td>
                                    <td width="20%" style="vertical-align: top; text-align: center">
                                        {{ transmittal.paymentTransmittalItems.length }}
                                    </td>
                                </tr>
                            }
                        </table>
                    </div>
                </td>
                <td>
                    @if (!isPrelimApFeed) {
                        @if (
                            !readOnly &&
                            !package.completedDateTime &&
                            !package.lockedForOverrideEmail
                        ) {
                            <textarea
                                (click)="$event.stopPropagation()"
                                [(ngModel)]="package.specialInstructions"
                                style="width: 100%; min-height: 70px"
                                maxlength="5000"
                                class="no-bubble"
                            ></textarea>
                        }
                        @if (readOnly || package.completedDateTime) {
                            <span>{{ package.specialInstructions }}</span>
                        }
                    }
                    @if (isPrelimApFeed) {
                        <div>N/A</div>
                    }
                </td>
                @if (
                    readOnly &&
                    !isModal &&
                    (package.completedDateTime || package.lockedForOverrideEmail)
                ) {
                    <td>
                        @if (!package.isRecalled) {
                            <button
                                [disabled]="package.paymentBatchId !== 0"
                                class="no-bubble ace-btn has-icon btn-text icon-dark"
                                (click)="recallPackage(package)"
                            >
                                <i class="fa fa-undo"></i>
                            </button>
                        }
                        @if (package.isRecalled) {
                            <span>(recalled)</span>
                        }
                    </td>
                }
            </tr>
        }
    </tbody>
</table>

<ng-template #recipientAddress>
    @if (hoveredRecipient) {
        <address style="text-align: left; margin: 0">
            {{ hoveredRecipient.companyName }}
            <br />
            {{ hoveredRecipient.fullName }} <br />
            {{ hoveredRecipient.title }}
            @if (hoveredRecipient.address) {
                <div>
                    {{ hoveredRecipient.address.address1 }}
                    <br />
                    {{ hoveredRecipient.address.address2 }}
                    @if (hoveredRecipient.address.address2) {
                        <br />
                    }
                    {{ hoveredRecipient.address.city }}
                    @if (hoveredRecipient.address.city) {
                        <span>,</span>
                    }
                    {{ hoveredRecipient.address.abbr }} {{ hoveredRecipient.address.zip }}
                </div>
            }
        </address>
    }
</ng-template>
